(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-catalogue"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nh-gallery')) {
  customElements.define('nh-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.cards = Array.from(this.querySelectorAll('[data-nh-card]'));
      this.select = this.querySelector('[data-nh-collection]');
      this.activeStyle = 'all';
      const requested = new URLSearchParams(window.location.search).get('nh_collection');
      if (this.select && Array.from(this.select.options).some(option => option.value === requested)) this.select.value = requested;
      this.select?.addEventListener('change', () => this.filter(), options);
      this.addEventListener('click', event => {
        const styleButton = event.target.closest('[data-nh-style]');
        if (styleButton) {
          this.activeStyle = styleButton.dataset.nhStyle;
          this.querySelectorAll('[data-nh-style]').forEach(button => button.setAttribute('aria-pressed', String(button === styleButton)));
          this.filter();
        }
        const roomButton = event.target.closest('[data-nh-room]');
        if (roomButton) {
          roomButton.closest('dialog')?.close();
          document.dispatchEvent(new CustomEvent('nh:visualize', { detail: { key: roomButton.dataset.nhRoom } }));
        }
        const pairButton = event.target.closest('[data-nh-room-pair]');
        if (pairButton) {
          pairButton.closest('dialog')?.close();
          if (document.querySelector('nh-room')) {
            document.dispatchEvent(new CustomEvent('nh:visualize-set', { detail: { keys: [pairButton.dataset.nhRoomPair], count: 2 } }));
          } else {
            const destination = new URL(this.dataset.rootUrl, window.location.origin);
            destination.searchParams.set('nh_set', pairButton.dataset.nhRoomPair);
            destination.searchParams.set('nh_count', '2');
            destination.hash = 'nh-room-visualizer';
            window.location.assign(destination.href);
          }
        }
        const opener = event.target.closest('[data-nh-open]');
        if (opener) document.getElementById(opener.dataset.nhOpen)?.showModal();
        if (event.target.closest('[data-nh-close]')) event.target.closest('dialog')?.close();
        if (event.target.closest('[data-nh-guide]')) event.target.closest('dialog')?.close();
        if (event.target instanceof HTMLDialogElement) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      }, options);
      this.filter();
    }
    filter() {
      const selected = this.select?.value || 'all';
      let count = 0;
      this.cards.forEach(card => {
        const visible = (selected === 'all' || card.dataset.collection === selected) && (this.activeStyle === 'all' || card.dataset.style === this.activeStyle);
        card.hidden = !visible;
        if (visible) count++;
      });
      this.querySelector('[data-nh-count]').textContent = String(count);
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
